import { ConversationPhase, MessageType } from "shared/types";

import { useCancelOrCompleteApplication, useMessageTypeExists } from "@/hooks";

import { DialogContent } from "shared/components";
import { PreReviewProposalContent } from "./PreReviewProposalContent";
import { PostReviewProposalContent } from "./PostReviewProposalContent";

export interface RestartDialogProps {
  conversationPhase: ConversationPhase;
  onOpenChange: (open: boolean) => void;
}

export function RestartDialog({ onOpenChange }: RestartDialogProps) {
  const isPreReviewProposal = !useMessageTypeExists({
    messageType: MessageType.REVIEW_PROPOSAL,
  });

  const {
    isPending: cancelOrCompleteApplicationLoading,
    cancelOrCompleteApplication,
  } = useCancelOrCompleteApplication({
    onSuccess: () => {
      onOpenChange(false);
    },
  });

  const handleClickRestart = () => {
    console.log("<RestartDialog> handleClickRestart()");
    cancelOrCompleteApplication();
  };

  return (
    <DialogContent
      aria-describedby={undefined}
      className="gap-4 md:max-w-[600px]"
    >
      {isPreReviewProposal ? (
        <PreReviewProposalContent
          onClickCancel={() => onOpenChange(false)}
          onClickSubmit={handleClickRestart}
          submitting={cancelOrCompleteApplicationLoading}
        />
      ) : (
        <PostReviewProposalContent
          onClickCancel={() => onOpenChange(false)}
          onClickSubmit={handleClickRestart}
          submitting={cancelOrCompleteApplicationLoading}
        />
      )}
    </DialogContent>
  );
}
